import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Single place to normalize backend errors. The backend wraps errors as
// { error, details? } via errorHandler.js; callers inspect
// err.response.data.error or err.response.data.details.
//
// A 401 means the auth cookie is gone or expired, so there is nothing the
// calling screen can usefully do but send the agent back to sign in. This
// lives here rather than in authService because it must apply to every API
// call, not only to the ones made after authService happens to be imported.
apiClient.interceptors.response.use(
  (resp) => resp,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.startsWith("/login")) {
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default apiClient;
